import Cookies from "js-cookie";
import TagManager from "react-gtm-module";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

// GTM code that was a script tag in the HTML
// This is now initialized in the initializeGoogleTagManager function
window.dataLayer = window.dataLayer || [];

export function gtag(feature: string, action: string, config: {}) {
  window.dataLayer.push({
    0: feature,
    1: action,
    2: config,
    callee: gtag,
    length: 3,
  });
}

type GTMConfig = {
  gtmId: string;
  auth?: string;
  preview?: string;
};

const getEnvironment = (): GTMConfig => {
  let gtmConfig: GTMConfig = {
    gtmId: "GTM-KDTFBS7D",
    preview: "env-1",
    auth: "QJpDZzu9f1XCdVtMo4Fc-Q",
  };

  const dev = { preview: "env-75", auth: "An8jr8JZFKxpoGo7afz7QA" };

  switch (process.env.NODE_ENV?.toLowerCase()) {
    case "local":
    case "development":
      gtmConfig.preview = dev.preview;
      gtmConfig.auth = dev.auth;
      break;
    case "systemtest":
      gtmConfig.preview = "env-76";
      gtmConfig.auth = "ixzKo6QoHn-ibgjBsifWYw";
      break;
    case "preprod":
      gtmConfig.preview = "env-76";
      gtmConfig.auth = "GdkyQhA7a5jsnq7wDlnz5w";
      break;
  }

  return gtmConfig;
};

export const initializeGoogleTagManager = (): void => {
  // Only initialize GTM - consent is already set in HTML
  setDefaultConsent();
  const gtmConfig = getEnvironment();
  TagManager.initialize({
    ...gtmConfig,
  });
};

export const setDefaultConsent = () => {
  const cookiesAccepted = Cookies.get("google-consent-response");
  const choice = cookiesAccepted === "granted" ? "granted" : "denied";

  gtag("consent", "default", {
    ad_storage: choice,
    ad_user_data: choice,
    ad_personalization: choice,
    analytics_storage: choice,
    wait_for_update: 500,
  });
};

export const updateConsent = (accepted: boolean) => {
  const choice = accepted ? "granted" : "denied";

  Cookies.set("google-consent-confirmed", "true", {
    expires: 150,
    secure: true,
  });

  Cookies.set("google-consent-response", choice, {
    expires: 150,
    secure: true,
  });

  gtag("consent", "update", {
    ad_storage: choice,
    ad_user_data: choice,
    ad_personalization: choice,
    analytics_storage: choice,
  });
};
